import * as Animate from "react-reveal";
import { ArrowUpRight } from "../../../components/svgs";

const steps = [
  {
    number: "01",
    title: "Diagnose",
    desc:
      "Clarify the capability gap, audience, business priorities and the outcomes that matter.",
  },
  {
    number: "02",
    title: "Design",
    desc:
      "Shape the curriculum, projects, delivery rhythm and success measures around your team.",
  },
  {
    number: "03",
    title: "Deliver",
    desc:
      "Combine live teaching, practical assignments, coaching and structured accountability.",
  },
  {
    number: "04",
    title: "Measure",
    desc:
      "Track participation, project performance, completion and the next capability priorities.",
  },
];

const PartnershipProcessSection = () => {
  return (
    <section
      className="bg-primary2 py-16 md:py-20 lg:py-24 px-4"
      id="how-it-works"
    >
      <div className="container mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-start">
          <Animate.Fade bottom>
            <div>
              <p className="flex items-center font-poppins gap-3 text-secondary text-sm font-extrabold tracking-widest uppercase mb-6">
                <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
                How the partnership works
              </p>
              <h2 className="text-3xl md:text-4xl lg:text-5xl leading-tight text-white font-poppins font-black mb-5 tracking-[-0.03em]">
                From capability gap to measurable learning progress.
              </h2>
              <p className="text-indigo-100 text-base font-poppins leading-relaxed mb-8">
                One connected delivery plan keeps the business objective,
                learner experience and evidence of progress aligned.
              </p>
              <a
                href="mailto:business@utiva.io?subject=Plan my academy"
                className="bg-secondary text-primary font-poppins font-extrabold rounded-xl inline-flex items-center gap-3 px-5 py-4 custom-btn"
              >
                Plan your academy <ArrowUpRight className="w-3.5 h-3.5" />
              </a>
            </div>
          </Animate.Fade>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {steps.map((step) => (
              <Animate.Fade bottom key={step.number}>
                <article
                  className="h-full rounded-2xl border border-white/15 p-6"
                  style={{ background: "rgba(255,255,255,0.06)" }}
                >
                  <span className="text-secondary font-poppins text-xs font-extrabold tracking-widest">
                    {step.number}
                  </span>
                  <h3 className="text-white font-poppins font-bold text-xl mt-3 mb-2.5">
                    {step.title}
                  </h3>
                  <p className="text-indigo-100 font-poppins text-sm leading-relaxed m-0">
                    {step.desc}
                  </p>
                </article>
              </Animate.Fade>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnershipProcessSection;
